module.exports = __webpack_public_path__ + "img/6.457ab114.webp";